/* ---------------------------------------------------
	プラグインのinclude用
 ----------------------------------------------------- */


/*  jquery
------------------------------------------------------ */
window.$ = window.jQuery = require('jquery');


/*  jquery.magnific-popup
------------------------------------------------------ */
require('magnific-popup');

/*  AOS
------------------------------------------------------ */
AOS = require('aos');
